// studentReducer.js
import {
    FETCH_STUDENTS_REQUEST,
    FETCH_STUDENTS_SUCCESS,
    FETCH_STUDENTS_FAILURE,
    ADD_STUDENT_REQUEST,
    ADD_STUDENT_SUCCESS,
    ADD_STUDENT_FAILURE,
    UPDATE_STUDENT_REQUEST,
    UPDATE_STUDENT_SUCCESS,
    UPDATE_STUDENT_FAILURE,
    DELETE_STUDENT_REQUEST,
    DELETE_STUDENT_SUCCESS,
    DELETE_STUDENT_FAILURE,
    FETCH_STUDENT_PROFILE_REQUEST,
    FETCH_STUDENT_PROFILE_SUCCESS,
    FETCH_STUDENT_PROFILE_FAILURE,
  } from "./actionTypes";
  
  const initialState = {
    students: [],
    profile:null, 
    loading: false,
    error: null,
  };
  
  const studentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_STUDENTS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_STUDENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          students: action.payload,
        };
  
      case FETCH_STUDENTS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_STUDENT_REQUEST:
      case UPDATE_STUDENT_REQUEST:
      case DELETE_STUDENT_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case ADD_STUDENT_SUCCESS:
        return {
          ...state,
          loading: false,
          students: {
            ...state?.students,
            data: [action.payload?.data,...state.students.data],
          },
        };
  
      case ADD_STUDENT_FAILURE:
      case UPDATE_STUDENT_FAILURE:
      case DELETE_STUDENT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case UPDATE_STUDENT_SUCCESS:
        return {
          ...state,
          loading: false,
          students: {
            ...state?.students,
            data: state.students.data?.map((item) =>
              item?.id == action.payload?.data?.id
                ? action.payload.data
                : item
            ),
          },
        };
  
      case DELETE_STUDENT_SUCCESS:
        return {
          ...state,
          loading: false,
          students: {
            ...state?.students,
            data: state.students.data?.filter(
              (item) => item?.id !== action.payload?.data?._id
            ),
          },
        };

      case FETCH_STUDENT_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        
      };

   case FETCH_STUDENT_PROFILE_SUCCESS:
  return {
    ...state,
    loading: false,
    profile: {
      ...state.profile,
      ...action.payload,
      assignments: {
        ...action.payload.assignments,
        
        submissions: action.payload.assignments.submissions,
      },
    },
  };

    case FETCH_STUDENT_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
  
      default:
        return state;
    }
  };
  
  export default studentReducer;
  

